export const environment = {
  env: "production",
  production: true,
  sandbox: false
};
